import React, {Component} from 'react'
import {Link} from 'react-router'
import DustMitePhoto from '../../images/dust_mite.jpg'
import Youtube from '../../Component/Youtube'

const Jeyu = {
  DustMiteBox: {
    background:'#9e3030',
    padding: '183px 10px 140px'

  },
  bannerPhotoBox: {
    width: 200,
    height: 200,
    overflow: 'hidden',
    borderRadius: 150,
    boxShadow: '1px 1px 7px rgba(0,0,0,.2)'
  },
  bannerPhoto: {
    width: 200,
    height: 200,
  },
  center: {
   display: 'block',
   textAlign: 'left'
  },
  h1: {
    fontSize: 30,
    textAlign: 'left',
    fontWeight: 'unset',
    color: '#fff',
    margin: '10px 0 0 0'
  },
  p: {
    fontSize: 20,
    color: '#fff',
    textAlign: 'left',
    fontWeight: 100
  },
  pinfo: {
    fontSize: 18,
    textAlign: 'left',
    margin: '20px 0',
    fontWeight: 100
  },
  h2: {
    fontSize: 23,
    fontWeight: 300
  },
  tag: {
    background: 'rgb(21, 222, 203)',
    color: 'rgb(1, 72, 82)',
    padding: '2px 15px',
    borderRadius: 7,
    fontSize: 16,
    marginRight: 10,
    fontWeight: 500
  },
  time: {
    marginLeft: 10
  },
  haspt: {
    paddingTop: 17
  },
  Section: {
    padding: '0 0 20px 0'
  },
  Article: {
    padding: 15
  }
}

export default class DustMite extends Component {
  componentDidMount () {
    window.scrollTo(0, 0)
  }
  componentWillUnmount() {
    window.scrollTo(0, 0)
  }
  render() {
    return(
      <div className="container-fluid">
       <div className="row">
        <div style={Jeyu.DustMiteBox} className="DustMiteBox">
         <div className="container">
          <div className="row">
           <div className="xs-12 sm-6 md-8 lg-8">
            <div style={Jeyu.haspt}>
             <p style={Jeyu.p}><Link to="/" style={Jeyu.tag}>塵蹣</Link> JeyuTex <time datetime="2017-04-20 13:30" style={Jeyu.time}>Apr 20, 2017</time></p>
             <h1 style={Jeyu.h1}>全世界兩千萬人過敏元凶:塵蹣</h1>
             <p style={Jeyu.p}>科學家確定塵蹣為室內過敏症的罪魁禍首塵蹣是灰塵中引起過敏的主因<br />認識塵瞞的相關知識,才能有效的制止塵瞞生長, 給自己健康的環境</p>
            </div>
           </div>
           <div className="xs-12 sm-6 md-4 lg-4">
            <div style={Jeyu.bannerPhotoBox} className="bannerPhotoBox">
             <img src={DustMitePhoto} alt="Dust Mite" style={Jeyu.bannerPhoto} className="bannerPhoto"/>
            </div>
           </div>
          </div>
         </div>
        </div>

        <div className="container">
         <div className="row">
          <section style={Jeyu.Section}>
          <article style={Jeyu.Article}>
           <h2 style={Jeyu.h2}>(塵蹣)我們每年平均吸入十大匙的灰塵</h2>
           <p style={Jeyu.pinfo}>但灰塵對多數人而言並不會造成困擾，<br />會造成困擾的是隱藏在家居塵埃中的微生物，如霉、黴菌、真菌與細菌，令數百萬人產生過敏反應</p>
          </article>
          <article style={Jeyu.Article}>
           <h2 style={Jeyu.h2}>(塵瞞)我們與一整群肉眼見不到的微生物同住一屋簷下</h2>
           <p style={Jeyu.pinfo}>
            它們生活在灰塵中或在流理台表面，附著在皮膚上又再由皮膚落入灰塵中，<br />
            你每次呼吸都將那些灰塵微粒吸進去，它們進入你的鼻子，喉嚨和肺
           </p>
           <p style={Jeyu.pinfo}>
            灰塵中含有危險性很高的東西<br />
            就是過敏原與製造過敏原的真菌孢子、塵蹣、蟑螂、貓狗的毛屑、鼠尿
           </p>
           <p style={Jeyu.pinfo}>
            其中又以塵瞞最難對付,<br />
            一般塵瞞大小為:在顯微鏡放大 100 倍下，塵螨全身透明，長約從 16~35 格之間（0.16~0.35mm），寬約從 8~15 格之間（0.08~0.15mm）。
           </p>
          </article>
          <article style={Jeyu.Article}>
           <h2 style={Jeyu.h2}>塵蹣分為兩種類</h2>
           <p style={Jeyu.pinfo}>
            1.被叮咬就強烈發癢的肉食蹣科
           </p>
           <p style={Jeyu.pinfo}>
            2.不叮咬人的蚍蹣科(不易被發覺)
           </p>
          </article>
          <article style={Jeyu.Article}>
           <h2 style={Jeyu.h2}>塵蹣住在哪裡?靠什麼維生?</h2>
           <p style={Jeyu.pinfo}>
            塵蹣在床，床墊及枕頭上建立家園普通床墊上就有高達200萬隻蹣<br />
            如果你的枕頭很舊，那麼它就有25%的重量可能是塵埃與塵蹣
           </p>
           <p style={Jeyu.pinfo}>
            塵蹣偏好床、枕頭與客廳沙發，因為塵蹣以人類剝落的死皮屑維生<br />
            科學家估計人類光是坐著，每分鐘就剝落40萬皮屑微粒，<br />而皮屑便成為灰塵的一部分聚集在床底下
           </p>
           <p style={Jeyu.pinfo}>
            皮屑開始長霉，塵蹣則開始以霉維生，於是灰塵聚集再一起，又招來更多灰塵，循環不止
           </p>
          </article>
          <article style={Jeyu.Article}>
           <h2 style={Jeyu.h2}>塵蹣喜歡什麼環境?</h2>
           <p style={Jeyu.pinfo}>
            塵蹣喜歡與人類一同出沒，它們等著享用人類剝落的皮屑<br />
            塵蹣會和人類同住一屋簷下，因為人類提供其所需的氣溫和食物，它們需要潮濕的環境來生存適合繁殖的濕度為60%以上
           </p>
          </article>
          <article style={Jeyu.Article}>
           <h2 style={Jeyu.h2}>為什麼塵蹣會讓我們有過敏反應?</h2>
           <p style={Jeyu.pinfo}>
            艾里安大夫已證實塵蹣糞便含有至少15種不同的蛋白質，會造成人類的過敏反應<br />
            塵蹣靠著吃皮屑而活，而且附著在霉菌上<br />
            塵蹣的排泄物和花粉核同大小，牠們密布空氣中並被吸進肺裡因此才引起過敏反應<br />
            塵蹣聚集在枕頭和床墊裡，而床單和枕頭套會將牠們和其分泌物保存於內
           </p>
          </article>
          <article style={Jeyu.Article}>
           <h2 style={Jeyu.h2}>塵蹣繁殖力相當驚人</h2>
           <p style={Jeyu.pinfo}>
            某檢察機關曾經做過一個實驗，156隻塵蹣經過3個月後滋長成8萬隻(500倍)<br />
            最重要的解決辦法是斬草除根！！！！如果放任不管，塵蹣就會在你周圍氾濫！
           </p>
          </article>
          </section>
         </div>
        </div>
        <Youtube />
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Blog/DustMite.js